<template>
  <div>
    <v-container fluid class="lighten-12 content">
      <v-container fluid>
        <v-row>
          <v-card-text class="pa-0">
            <v-row>
              <v-col cols="12" lg="4" sm="12">
                <v-autocomplete
                  hide-details="auto"
                  :items="warehouses"
                  :loading="loadingShops"
                  v-model="selectedwarehouse"
                  @input="getAllProducts(searchDate)"
                  item-text="name"
                  item-value="id"
                  label="Warehouse"
                  outlined
                  dense
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="4" sm="12"></v-col>
              <v-col cols="12" lg="3" sm="12">
                <DatePicker
                  :labelname="'Date'"
                  v-model="searchDate"
                  @input="getAllProducts(searchDate)"
                  :max="Datemax"
                />
                <!-- <v-text-field
                      hide-details="auto"
                      v-model="search"
                      dense
                      outlined
                      clearable
                      @input="getAllProducts(search)"
                      placeholder="Search"
                      append-icon="mdi-magnify"
                  ></v-text-field> -->
              </v-col>
              <v-col cols="12" sm="12">
                <TableHeaderFilter :columns="columns" />
              </v-col>
            </v-row>

            <v-card-title class="d-flex justify-space-between"
              >Stock Details
              <v-btn
                hidden
                small
                class="text-white btn_gray w-100 d-none d-sm-flex"
                v-print="printQr"
                >Print <v-icon right dark> mdi-printer </v-icon></v-btn
              ></v-card-title
            >
            <StockProductsTemplate
              :datas="data"
              :data="productDetails"
              class="test1"
              id="products"
              :columns="columns"
              style="display: none"
            />
            <v-simple-table fixed-header dense>
              <template v-slot:default>
                <div
                  v-if="productDetails.length == 0"
                  class="mt-16 container justify-center item-center"
                >
                  <img
                    style="height: 200px"
                    src="../../assets/img/no-result.jpg"
                  />
                </div>
                <thead v-if="productDetails.length > 0">
                  <tr>
                    <th
                      class="text-left"
                      v-if="col.show"
                      v-for="(col, index) in columns"
                    >
                      {{ col.text }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in productDetails" :key="item.name">
                    <td v-if="columns[0].show">{{ index + 1 }}</td>
                    <td v-if="columns[1].show">{{ item.product.name }}</td>
                    <td v-if="columns[2].show">{{ item.date | formatDate }}</td>
                    <td v-if="columns[3].show">{{ item.unit.name }}</td>
                    <td v-if="columns[4].show">{{ item.batch.batch }}</td>
                    <td v-if="columns[5].show">{{ item.available_stock }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-row>
      </v-container>
    </v-container>
    <div class="d-flex justify-center align-center"></div>
    <!-- </v-row> -->
  </div>
</template>

<script>
// Components
import PageTitle from '@/components/shared/PageTitle';
import DatePicker from '@/components/base/DateComponent.vue';
import TableFilters from '@/components/base/TableFilters';
import StockProductsTemplate from '@/components/PrintTemplates/StockDetailsTemplate.vue';
import moment from 'moment';

export default {
  data: () => ({
    warehouses: [],
    searchDate: moment(new Date()).subtract(1, 'days').format('YYYY-MM-DD'),
    Datemax: moment(new Date()).subtract(1, 'days').format('YYYY-MM-DD'),
    products: [],
    data: {
      type: 'Warehouse',
      warehouse: null,
    },
    search: null,
    selectedwarehouse: null,
    productDetails: [],
    loadingShops: false,
    columns: [
      {
        text: 'No',
        show: true,
        width: '20%',
      },
      {
        text: 'Name',
        show: true,
        disabled: true,
        width: '20%',
      },
      {
        text: 'Date',
        show: true,
        width: '20%',
      },
      {
        text: 'Brand',
        show: true,
        width: '20%',
      },

      {
        text: 'Unit',
        show: true,
        disabled: true,
        width: '20%',
      },

      {
        text: 'Available stock',
        show: true,
        width: '20%',
        width: 60,
      },
    ],
  }),
  components: {
    PageTitle,
    TableFilters,
    StockProductsTemplate,
    DatePicker,
  },

  methods: {
    async getAllProducts(value) {
      await this.$store
        .dispatch('report/GetWarehouseStocks', {
          query: value,
          warehouseId: this.selectedwarehouse,
        })
        .then((res) => {
          this.products = res.data.data;

          this.data.warehouse = this.warehouses.find(
            (p) => p.id == this.selectedwarehouse,
          );

          this.productDetails = this.products;
        })
        .catch((err) => {});
    },
    async getAllShops(value) {
      await this.$store
        .dispatch('warehouse/GetWarehouses', {})
        .then((res) => {
          this.warehouses = res;
          this.selectedwarehouse = 1;
          this.getAllProducts(this.searchDate);
        })
        .catch((err) => {});
    },
  },

  created() {
    this.getAllShops('');
  },
  computed: {
    printQr() {
      return {
        id: 'products',
        popTitle: 'Product Details',
      };
    },
  },
};
</script>
